import { themeColors } from '../../themeColors';
/**
 * @file   src\mobile\components\propertyAd.js
 * @brief  This file is responsible for property add icon
 * @date   April, 2024
 * @author ZCO Engineer
 * @copyright (c) 2024, ZCO
 */
import React from "react";

const PropertyIcn = (props) => {
  return (
    <a href={void 0} role="button" className=" text-center ">
      <svg
        width="21"
        height="20"
        viewBox="0 0 21 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g id="House">
          <path
            id="Vector"
            d="M10.5 2.08984C10.0214 2.08984 9.54293 2.24553 9.14746 2.55697H9.14665L4.19141 6.4624C3.43992 7.05464 3 7.95958 3 8.91683V16.4535C3 17.2513 3.66044 17.9118 4.45833 17.9118H16.5417C17.3396 17.9118 18 17.2513 18 16.4535V8.91683C18 7.95958 17.5601 7.05464 16.8086 6.4624L16.75 6.4152V3.125C16.75 2.95924 16.6841 2.80028 16.5669 2.68308C16.4497 2.56587 16.2908 2.50002 16.125 2.5H14.0417C13.8759 2.50002 13.7169 2.56587 13.5997 2.68308C13.4825 2.80028 13.4167 2.95924 13.4167 3.125V3.78906L11.8525 2.55697C11.4571 2.24553 10.9786 2.08984 10.5 2.08984ZM10.5 3.33659C10.7041 3.33659 10.9082 3.40441 11.0794 3.53923L13.6551 5.56803C13.7473 5.64054 13.858 5.68566 13.9746 5.69824C14.0911 5.71082 14.2089 5.69035 14.3144 5.63917C14.4199 5.58798 14.5089 5.50815 14.5712 5.4088C14.6335 5.30945 14.6666 5.19458 14.6667 5.07731V3.75H15.5V6.71875C15.5001 6.81325 15.5216 6.9065 15.5629 6.9915C15.6042 7.0765 15.6642 7.15102 15.7384 7.20947L16.0355 7.44385C16.4873 7.79994 16.75 8.34158 16.75 8.91683V16.4535C16.75 16.5764 16.6646 16.6618 16.5417 16.6618H4.45833C4.3354 16.6618 4.25 16.5764 4.25 16.4535V8.91683C4.25 8.34158 4.51267 7.79994 4.96452 7.44385L9.92057 3.53923C10.0918 3.40441 10.2959 3.33659 10.5 3.33659ZM6.54167 9.99512C6.37591 9.99513 6.21695 10.061 6.09974 10.1782C5.98254 10.2954 5.91668 10.4544 5.91667 10.6201V13.9535C5.91668 14.1192 5.98254 14.2782 6.09974 14.3954C6.21695 14.5126 6.37591 14.5784 6.54167 14.5785H9.04167C9.20742 14.5784 9.36638 14.5126 9.48359 14.3954C9.6008 14.2782 9.66665 14.1192 9.66667 13.9535V10.6201C9.66665 10.4544 9.6008 10.2954 9.48359 10.1782C9.36638 10.061 9.20742 9.99513 9.04167 9.99512H6.54167ZM11.9583 9.99512C11.7926 9.99513 11.6336 10.061 11.5164 10.1782C11.3992 10.2954 11.3334 10.4544 11.3333 10.6201V13.9535C11.3334 14.1192 11.3992 14.2782 11.5164 14.3954C11.6336 14.5126 11.7926 14.5784 11.9583 14.5785H14.4583C14.6241 14.5784 14.783 14.5126 14.9003 14.3954C15.0175 14.2782 15.0833 14.1192 15.0833 13.9535V10.6201C15.0833 10.4544 15.0175 10.2954 14.9003 10.1782C14.783 10.061 14.6241 9.99513 14.4583 9.99512H11.9583ZM7.16667 11.2451H8.41667V13.3285H7.16667V11.2451ZM12.5833 11.2451H13.8333V13.3285H12.5833V11.2451Z"
            fill={themeColors.neutral890}
          />
        </g>
      </svg>

      <span> &nbsp; Property</span>
    </a>
  );
};

export default PropertyIcn;
